import { createSelector } from 'reselect'

export const getDiscounts = createSelector(
  state => state && state.user && state.user.packages && Array.isArray(state.user.packages.discounts)
    ? state.user.packages.discounts : [],
  discounts => discounts
)
